import L from "leaflet";
import { getElements } from "./utils";
import { locations } from "./db.js";
import LocationCard from "./components/LocationCard";

const {
  counterMember,
  counterNoMember,
  sideBar,
  sidbarToggleButton,
  locationFilter,
  clearLocationFilterButton,
  cardContainer,
} = getElements(document);

// initialize the map
var map = L.map("myMap", {
  center: [51.495, 10.179],
  zoom: 7,
});

L.tileLayer('https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png', 
  {
	  attribution:
     '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>',
	  subdomains: 'abcd',
	  maxZoom: 20,
  }
).addTo(map);
map.zoomControl.setPosition("bottomleft");

// // Dev utils
// function updateCoordsDisplay() {
//   const coords = map.getCenter();
//   coordsOutput.textContent = `[${coords.lat.toFixed(3)}, ${coords.lng.toFixed(
//     3
//   )}]`;
// }
// updateCoordsDisplay();

// map.on("move", updateCoordsDisplay);

// const centerMarker = document.createElement("div");
// centerMarker.textContent = "+";
// centerMarker.classList.add("center-marker");
// document.body.append(centerMarker);

sidbarToggleButton.addEventListener("click", () => {
  sideBar.classList.toggle("closed");
});

// update counter

counterMember.textContent = locations.filter(
  (location) => location.isMember
).length;

counterNoMember.textContent = locations.filter(
  (location) => !location.isMember
).length;

// add a marker to the map
locations.forEach((location) => {
  const card = LocationCard({
    ...location,
    onMapButtonClick: () => {
      map.flyTo(location.latlng, 10, { duration: 3 });
    },
  });
  L.circleMarker(location.latlng, {
    stroke: false,
    fill: true,
    fillColor: location.isMember ? "var(--red)" : "var(--primary)",
    fillOpacity: 1,
    radius: 6,
    className: "location-marker",
  })
    .addTo(map)
    .bindPopup(card);
  cardContainer.append(card);
});

locationFilter.addEventListener("input", (event) => {
  const query = event.target.value.toLowerCase();
  cardContainer.innerHTML = "";
  locations
    .filter((location) => !query || location.name.toLowerCase().includes(query))
    .map(LocationCard)
    .forEach((card) => cardContainer.append(card));
});

clearLocationFilterButton.addEventListener("click", () => {
  locationFilter.value = "";
  locationFilter.dispatchEvent(new Event("input"));
});
